import { properties } from '@/utils/properties';
import { Util } from '@/utils/util';
import { Component, HostListener, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FormularioColaboradorComponent } from './formulario-colaborador/formulario-colaborador.component';
import { CatalogoColaboradorService } from '@services/catalogo/catalogoColaborador.service';
import { Colaborador } from '@/store/catalogos/colaborador';

@Component({
  selector: 'app-colaborador',
  templateUrl: './colaborador.component.html',
  styleUrls: ['./colaborador.component.css'] 
})
export class ColaboradorComponent {
  PROP = properties;
  displayedColumns: string[] = ['nombreCompleto', 'fechaNacimiento', 'sexo', 'status', 'options'];
  dataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private paginator1: MatPaginatorIntl,
    private catalogService: CatalogoColaboradorService,
    public dialog: MatDialog,
    private util: Util
  ) {
    this.paginator1.itemsPerPageLabel = "Registros por página";
  }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.loadColaboradores();
    this.adjustColumnsForMobile();
    window.addEventListener('resize', () => this.adjustColumnsForMobile());
  }

  loadColaboradores() {
    this.catalogService.getAll().subscribe(data => {
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });

  }

  filterTable(event: Event) {
    const filtro = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filtro.trim().toLowerCase();
  }

  new() {
    const dialogRef = this.dialog.open(FormularioColaboradorComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
      disableClose: true,
      data: { insert: true, update: false, view: false, row: null }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadColaboradores();
      }
    });
  }

  update(row: Colaborador) {
    const dialogRef = this.dialog.open(FormularioColaboradorComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
      disableClose: true,
      data: { insert: false, update: true, view: false, row: row }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadColaboradores();
      }
    });
  }

  view(row: Colaborador) {
    const dialogRef = this.dialog.open(FormularioColaboradorComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
      disableClose: true,
      data: { insert: false, update: false, view: true, row: row }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadColaboradores();
      }
    });
  }

  updateStatus(row: any) {
    this.catalogService.updateStatus(row.idColaborador).subscribe(
      (response) => {
        if (response.success) {
          this.util.successMessage('Estatus actualizado correctamente');
          this.loadColaboradores();
        } else {
          this.util.errorMessage('Error al actualizar el estatus');
        }
      },
      (error) => {
        this.util.errorMessage('Error en la solicitud: ' + error.message);
      }
    );
  }
  
  @HostListener('window:resize', ['$event'])
  adjustColumnsForMobile() {
    if (window.innerWidth <= 767.98) {
      this.displayedColumns = ['nombreCompleto','fechaNacimiento', 'status', 'options'];
    } else {
      this.displayedColumns = ['nombreCompleto', 'fechaNacimiento', 'sexo', 'status', 'options'];
    }
  }
}